import { useCallback } from "react";

export const useClick = () => {
  const handleWhite = useCallback(() => {
    window.open("/pdf/whitepaper.pdf", "_blank");
  }, []);
  const handleEconomics = useCallback(() => {
    window.open("/pdf/litepaper.pdf", "_blank");
  }, []);
  return {
    handleWhite,
    handleEconomics,
  };
};
